module.exports = __webpack_public_path__ + "img/culture2.bf013ba0.jpg";